import {Injectable, Injector} from "@angular/core";
import {ReportError} from "app/app.service";

import {BaseListService, BatchRequest, BatchResponse} from "app/services/domain/base.service";
import * as Models from "app/services/proxy/model/models";
import {Lookup} from "framework/services/utils.service";

@Injectable()
export class ComplianceAssessmentHistoryListService extends BaseListService<Models.ComplianceAssessmentHistoryListRequest, BatchRequest, Models.ComplianceAssessmentHistoryDetail>
{
    private readonly m_historyByTenant: Lookup<Models.ComplianceAssessmentHistoryDetail[]>         = {};
    private readonly m_fetchingByTenant: Lookup<Promise<Models.ComplianceAssessmentHistoryDetail[]>> = {};

    constructor(inj: Injector)
    {
        super(inj, Models.ComplianceAssessmentHistoryDetail);
    }

    @ReportError
    public list(listReq: Models.ComplianceAssessmentHistoryListRequest): Promise<Models.ListResponse>
    {
        return this.domain.apis.compliance.complianceAssessmentHistoryList(listReq) as Promise<Models.ListResponse>;
    }

    @ReportError
    protected async getBatchResponseImpl(req: BatchRequest): Promise<BatchResponse<Models.ComplianceAssessmentHistoryDetail>>
    {
        const items = await this.domain.apis.compliance.complianceAssessmentHistoryBatch(
            Models.ComplianceAssessmentHistoryBatchRequest.newInstance({compliance_assessment_history_ids: this.getSysIds(req)})
        );
        const lookup: Lookup<Models.ComplianceAssessmentHistoryDetail> = {};
        for (const item of items || [])
        {
            lookup[item.compliance_assessment_history_id] = item;
        }
        return {results: lookup};
    }

    protected createBatchRequest(listReq: Models.ComplianceAssessmentHistoryListRequest,
                                 ids: string[]): BatchRequest
    {
        return {ids};
    }

    public async getAllForTenant(tenantId: string): Promise<Models.ComplianceAssessmentHistoryDetail[]>
    {
        if (this.m_historyByTenant[tenantId])
        {
            return this.m_historyByTenant[tenantId];
        }

        if (!this.m_fetchingByTenant[tenantId])
        {
            this.m_fetchingByTenant[tenantId] = (async () =>
            {
                try
                {
                    const sortCriteria = Models.ComplianceAssessmentHistorySortCriteria.newInstance({
                                                                                                          column   : Models.ComplianceAssessmentHistorySortColumn.created_at,
                                                                                                          ascending: false
                                                                                                      });
                    const request       = Models.ComplianceAssessmentHistoryListRequest.newInstance({
                                                                                                          list_context: Models.ListContext.newInstance({
                                                                                                                                                           batch_size  : 500,
                                                                                                                                                           batch_offset: 0
                                                                                                                                                       }),
                                                                                                          sort        : [sortCriteria],
                                                                                                          filters     : Models.ComplianceAssessmentHistoryFilter.newInstance({
                                                                                                                                                                                tenant_id: tenantId
                                                                                                                                                                            })
                                                                                                      });
                    const pairs                       = await this.getAll(request);
                    this.m_historyByTenant[tenantId] = pairs?.map(([, item]) => item) || [];
                }
                finally
                {
                    delete this.m_fetchingByTenant[tenantId];
                }

                return this.m_historyByTenant[tenantId];
            })();
        }

        return this.m_fetchingByTenant[tenantId];
    }

    public resetTenantCache(tenantId: string): void
    {
        this.m_historyByTenant[tenantId] = null;
    }
}
